import { BillingView } from "@/components/common/account/AccountViews";

export default function BillMobile() {
  return <BillingView isMobile={true} />;
}
